import * as React from 'react'

import { Href, Text } from '@factorialco/deprecated-design-system'

import { observer } from 'mobx-react'

import { track, trackingEvents } from 'modules/core/lib/Tracking'
import helpCenterUrl from 'modules/core/lib/helpCenterUrl'
import i18n from 'modules/core/lib/i18n'
import { employeeUser } from 'modules/core/store/collections/users'

import type ContractFlow from 'modules/contracts/lib/ContractFlow'
import type Employee from 'modules/employees/store/models/Employee'

interface Props {
  flow: ContractFlow
  employee: Employee
}

const Footer = ({ flow, employee }: Props) => {
  const trackFooterLink = () => {
    track(trackingEvents.employee.contracts.goToFooterLink, {
      step: flow.currentStepNumber + 1,
      type: 'fix',
    })
  }
  return (
    <Href
      onClick={() => trackFooterLink()}
      href={helpCenterUrl('manage_contracts_fix')}
      target="_blank"
    >
      <Text.Normal weight="medium" size="100">
        {i18n.t('contract_versions.flows.fix.footer.content', {
          employeeFullName: employeeUser(employee).fullName(),
        })}
      </Text.Normal>
    </Href>
  )
}

export default observer(Footer)
